'use client';

import useVelocityAccountStore, {
	AccountData,
} from 'src/stores/useVelocityAccountsStore';
import useWalletIsConnected from './useWalletIsConnected';

const DEFAULT_STATE: AccountData | undefined = undefined;

const useTargetAccountData = (userKey?: string): AccountData | undefined => {
	const currentUserKey = useVelocityAccountStore((s) => s.currentUserKey);
	const isConnected = useWalletIsConnected();

	const currentAccounts = useVelocityAccountStore((s) => s.accounts);

	const currentAccount = currentAccounts[userKey ?? currentUserKey ?? ''];

	const accountData =
		isConnected && currentAccount ? currentAccount : DEFAULT_STATE;

	return accountData;
};

export default useTargetAccountData;
